// @ts-nocheck
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useStores } from "hooks/useStores";
import { IMaskInput } from "react-imask";
import { lkSchema } from "./schema";
import {observer} from "mobx-react";
import LkChangePassword from "./lkChangePassword";
import LkCreatePhone from "./lkCreatePhone";
import LkCreateEmailNew from "./LkCreateEmailNew";
import LkChangePhone from "./lkChangePhone";
import LkChangeEmailNew from "./LkChangeEmailNew";

export const LkPersonalForm = observer(() => {
  const [modalReady, setModalReady] = useState(1);
  const [modalPassReady, setModalPassReady] = useState(1);
  const [modalPhoneReady, setModalPhoneReady] = useState(1);
  const [modalPhoneChange, setModalPhoneChange] = useState(1);
  const [modalCreateEmail, setModalCreateEmail] = useState(1);
  const { api, userStore }= useStores();

  const lkChangeEmailFunction = () => {
    document.querySelector("#changeEmailPopup").style.display = "flex";
    setModalReady(modalReady + 1);
  };

  const lkCreateEmailFunction = () => {
    document.querySelector("#createEmailPopup").style.display = "flex";
    setModalCreateEmail(modalCreateEmail + 1);
  };

  const lkChangePasswordFunction = () => {
    document.querySelector("#changePasswordPopup").style.display = "flex";
    setModalPassReady(modalPassReady + 1);
  };

  const lkCreatePhoneFunction = () => {
    document.querySelector("#createPhonePopup").style.display = "flex";
    setModalPhoneReady(modalPhoneReady + 1);
  };

  const lkChangePhoneFunction = () => {
    document.querySelector("#changePhonePopup").style.display = "flex";
    setModalPhoneReady(modalPhoneReady + 1);
  };


  const [personalDataChanged, setPersonalDataChanged] = useState(false);

  const { currentUser } = userStore;

  const [isLoadedCurrentUser, setIsLoadedCurrentUser] = useState(true);
  const [agreement, setAgreement] = useState("");

  const handleCancelClick = () => {
    reset(currentUser)
  }

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(lkSchema),
    defaultValues: currentUser
  });

  const onSubmit = (data) => {
    const dataToPost = {
      first_name: data.first_name,
      last_name: data.last_name,
      company: data.company,
      position: data.position,
    };

    api.user.postCahngePd(dataToPost)
      .then(() => {
        setPersonalDataChanged(true);
        userStore.getUser()
      })
      .catch((err) => {
        if (err.response.status === 500) {
        }
      });
  };

  useEffect(() => {
    api.content.getPageApi("glavnaya")
      .then((res) => {
        setAgreement(res.init_state.policy);
      });
  }, []);

  useEffect(() => {
    reset(currentUser)
  }, [currentUser])

  return (
    <>
      {isLoadedCurrentUser && (
        <form className='lk-personal-form' onSubmit={handleSubmit(onSubmit)}>
          <div className='lk-personal-form-item'>
            <label htmlFor='name'>
              Имя<span className='lk-personal-form__span'>*</span>
            </label>
            <input
              {...register("first_name")}
              id='first_name'
              name='first_name'
              type='text'
              className='lk-personal-input'
              maxLength='50'
            />
            <p className='lk-personal-form__err'>{errors.first_name?.message}</p>
          </div>
          <div className='lk-personal-form-item'>
            <label htmlFor='lastName'>Фамилия</label>
            <input
              {...register("last_name")}
              id='last_name'
              name='last_name'
              type='text'
              className='lk-personal-input'
              maxLength='50'
            />
            <p className='lk-personal-form__err'>{errors.last_name?.message}</p>
          </div>
          <div className='lk-personal-form-item'>
            <label htmlFor='phone'>
              Контактный номер телефона
              <span className='lk-personal-form__span'>*</span>
            </label>
            <Controller
              render={({field: {onChange, value}}) => (
                <IMaskInput
                  className='lk-personal-input lk-personal-input-phone'
                  mask={"+{7} 000 000-00-00"}
                  unmask={true}
                  placeholder='+7 (___)'
                  onAccept={(val) => onChange(val)}
                  disabled={true}
                  value={currentUser?.phone}
                />
              )}
              id='phone'
              name='phone'
              type='tel'
              control={control}
              value={currentUser?.phone}
            />
            <p className='lk-personal-form__err'>{errors?.phone?.message}</p>
            {currentUser?.phone === '' ? (
              <button
                type="button"
                onClick={ lkCreatePhoneFunction }
                className='lk-personal-changeLink '
              >
                Указать номер телефона
              </button>
            )
            :
            (
              <button
                type="button"
                onClick={ lkChangePhoneFunction }
                className='lk-personal-changeLink '
              >
                Изменить номер телефона
              </button>
            )}
          </div>
          <div className='lk-personal-form-item'>
            <label htmlFor='company'>Компания</label>
            <input
              {...register("company")}
              id='company'
              name='company'
              type='text'
              className='lk-personal-input'
              maxLength={50}
            />
            <p className='lk-personal-form__err'>{errors.company?.message}</p>
          </div>
          <div className='lk-personal-form-item'>
            <label htmlFor='position'>Должность</label>
            <input
              {...register("position")}
              id='position'
              name='position'
              type='text'
              className='lk-personal-input'
              maxLength={50}
            />
          </div>
          <div className='lk-personal-form-item'>
            <label htmlFor='email'>
              Email<span className='lk-personal-form__span'>*</span>
            </label>
            <input
              {...register("email")}
              id='email'
              name='email'
              type='email'
              className='lk-personal-input lk-personal-input-email'
              value={currentUser?.email}
              disabled
            />
            {currentUser?.email === '' ? <button
              type="button"
              onClick={ lkCreateEmailFunction }
              className='lk-personal-changeLink_addEmail'
            >
              Указать email
            </button> : <button
              type="button"
              onClick={ lkChangeEmailFunction }
              className='lk-personal-changeLink_changeEmail '
            >
              Изменить email
            </button>
            }
          </div>
          <button
            type="button"
            onClick={lkChangePasswordFunction}
            className='lk-personal-changePassword'
          >
            Изменить пароль
          </button>
          <div className='lk-personal-border'/>
          <div className='lk-personal-formFooter'>
            <div className='lk-personal-formFooter-text-wrapper'>
              <div className='lk-personal-formFooter-text'>
                ООО «СПП» ни при каких обстоятельствах не предоставляет третьим
                лицам персональную информацию своих пользователей, кроме
                случаев, прямо предусмотренных в{" "}
                <span>
                  <a href={agreement}>Политике конфиденциальности</a>
                </span>
              </div>
            </div>
            {personalDataChanged && (
              <div className='lk-personal-formFooter-succes'>
                Изменения на Вашей странице сохранены
              </div>
            )}
            <div className='lk-personal-formFooter-buttons'>
              <button type="button" onClick={handleCancelClick} className='lk-personal-formFooter-back'>
                Отмена
              </button>
              <button type="submit" className='lk-personal-formFooter-save'>Сохранить</button>
            </div>
          </div>
        </form>
      )}
      <LkChangeEmailNew email={ currentUser?.email } modal={ modalReady } />
      <LkChangePassword modal={ modalPassReady } />
      <LkChangePhone modal={ modalPhoneChange } />
      <LkCreatePhone modal={ modalPhoneReady } />
      <LkCreateEmailNew email={ currentUser?.email } modal={ modalCreateEmail } />
    </>
  );
})
